"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var LinearProgress_1 = __importDefault(require("@mui/material/LinearProgress"));
var makeLinearProgressStyling_1 = __importDefault(require("./makeLinearProgressStyling"));
var LoadingIndicator = function (_a) {
    var id = _a.id;
    var linearProgressStyles = (0, makeLinearProgressStyling_1.default)();
    return ((0, jsx_runtime_1.jsx)(LinearProgress_1.default, { id: id, css: linearProgressStyles, "data-testid": "loadingIndicator" }));
};
exports.default = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map